import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { configs } from '../configs'
import { extractSearchParams } from '../utils/extractSearchParams'

export type RosterEntry = {
  age?: number;
  bib?: string;
  city?: string;
  country?: string;
  displayName: string;
  gender?: "M" | "F" | "NB" | "U";
  private?: boolean;
  region?: string;
  status: "CONF" | "WITHDRAWN";
  team?: string;
}

export type BibNameSearchResult = {
  age: number;
  bib: string;
  displayName: string;
  eventCourseId: number;
  gender: "M" | "F" | "NB" | "U";
}

export const reigniteApi = createApi({
  reducerPath: 'reigniteApi',
  baseQuery: fetchBaseQuery({ baseUrl: configs.athleteApiUrl }),
  endpoints: (builder) => ({
    getRoster: builder.query<{
      page: number
      pageSize: number
      results: RosterEntry[]
      total: number
    }, {
      eventCourseId: number
      page: number
      pageSize: number
      term?: string
    }>({
      query: ({
        eventCourseId,
        ...params
      }: {
        eventCourseId: number
        page: number
        pageSize: number
        term?: string
      }) => `/roster/eventCourse/${eventCourseId}?${extractSearchParams(params)}`,
    }),
    getResultsBibNameSearch: builder.query<BibNameSearchResult[], {
      eventId: number
      from: number
      limit: number
      term?: string
    }>({
      query: ({
        eventId,
        ...params
      }) => `/results/event/${eventId}/search?${extractSearchParams(params)}`
    }),
  }),
})

export const {
  useGetResultsBibNameSearchQuery,
  useGetRosterQuery,
} = reigniteApi